import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'CustomReport',
    column_type: 'id',
  },
  created_at: {
    model_name: 'CustomReport',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'CustomReport',
    column_type: 'datetime',
  },
  target_type: {
    model_name: 'CustomReport',
    column_type: 'string',
  },
  kind: {
    model_name: 'CustomReport',
    column_type: 'enum',
  },
  target: {
    model_name: 'CustomReport',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: '',
    },
  },
  target_id: {
    model_name: 'CustomReport',
    column_type: 'belongs_to',
    extra: {
      association_name: 'target',
      model_name: '',
    },
  },
  start_at: {
    model_name: 'CustomReport',
    column_type: 'datetime',
  },
  end_at: {
    model_name: 'CustomReport',
    column_type: 'datetime',
  },
  owner_type: {
    model_name: 'CustomReport',
    column_type: 'string',
  },
  owner: {
    model_name: 'CustomReport',
    column_type: 'belongs_to',
    extra: {
      association_name: 'owner',
      model_name: '',
    },
  },
  owner_id: {
    model_name: 'CustomReport',
    column_type: 'belongs_to',
    extra: {
      association_name: 'owner',
      model_name: '',
    },
  },
  data: {
    model_name: 'CustomReport',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
